import { isObject } from "./index"
const TokenKey = 'Token'
const hciToken = 'hciToken'
const UserInfo = 'UserInfo'
const TIME = 'Time'
const EXP = 1000 * 60
const AllQuestion = 'AllQuestion'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function getHciToken() {
  return localStorage.getItem(hciToken) || ''
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function setUserLocalData(obj) {
  if(isObject(obj)){
    let str = ''

    try {
      str = JSON.stringify(obj)
    }catch (e) {
      console.log('用户信息格式错误')
    }

    localStorage.setItem(UserInfo, str)
  }else{
    console.log('用户信息格式错误')
  }
}

export function getUserLocalData() {
  let str = localStorage.getItem(UserInfo) || "{}"
  let obj = JSON.parse(str)
  return obj
}

export function setTime(timeData) {
  if(!isObject(timeData)) return
  const oldValue = localStorage.getItem(TIME) || "[]"
  let oldValueArr = JSON.parse(oldValue)
  const timestap = new Date().getTime()

  const expFilter = oldValueArr.filter(item => timestap - item.time < EXP)
  oldValueArr = expFilter

  const res = oldValueArr.find(item => item.key === timeData.key)

  if(res){
    for(let i = 0, l = oldValueArr.length; i < l; i++){
      if(oldValueArr[i].key === timeData.key){
        oldValueArr[i].value = timeData.value
        oldValueArr[i].time = timestap
        break
      }
    }
  }else{
    timeData.time = timestap
    oldValueArr.push(timeData)
  }

  const newValueJSON = JSON.stringify(oldValueArr)

  localStorage.setItem(TIME, newValueJSON)
}

export function getTime(key) {
  const timestap = new Date().getTime()
  const str = localStorage.getItem(TIME) || "[]"
  const arr = JSON.parse(str)

  const resFilter = arr.find(item => item.key === key)
  let res = 0

  if(resFilter){
    if(timestap - resFilter.time < EXP){
      res = resFilter.value
    }
  }
  return res
}

export function initSocketMsgData(data) {
  let localData = getUserLocalData()
  let baseData = {
    role: 'STUDENT',
    user_id: parseInt(localData.userId),
    subject_id: parseInt(localData.subjectId),
    school_id: parseInt(localData.schoolId),
    course_id: parseInt(localData.courseId),
    lesson_id: parseInt(localData.lessonId),
    topic_id: parseInt(localData.topicId),
    flow_id: parseInt(localData.flowId),
    stage: 40,
    nick: localData.userName,
    app_type: parseInt(localData.appType),
    client_ip: localData.clientIp,
  }
  let msg = Object.assign({}, baseData, data)
  return msg
}


export function setAllQuestionData(obj) {
  if(Array.isArray(obj)){
    let str = ''

    try {
      str = JSON.stringify(obj)
    }catch (e) {
      console.log('题目详情格式错误')
    }

    localStorage.setItem(AllQuestion, str)
  }else{
    console.log('题目详情格式错误')
  }
}

export function getAllQuestionData() {
  let str = localStorage.getItem(AllQuestion) || "[]"
  let obj = JSON.parse(str)
  return obj
}

function parse(txt){
  return JSON.parse(txt)
}

function stringify(obj){
  return JSON.stringify(obj)
}
/**
 * Get data by key
 *
 * @param {string} key  The key to get the data for
 * @return {val|object} The JSON.parse()`d data
 */
export function setStorage (key,val) {
  return sessionStorage.setItem(key, stringify(val))
}

export function getStorage (key) {
  return parse(sessionStorage.getItem(key) || '{}')
}

// 语文 userinfo设置与获取
export function chGetUserInfo () {
  var user = sessionStorage.getItem(UserInfo)
  return user ? parse(user) : {}
}

export function chSetUserInfo (userInfo) {
  return sessionStorage.setItem(UserInfo, stringify(userInfo))
}

export function chRemoveUserInfo () {
  return sessionStorage.removeItem(UserInfo)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js